export class ScarceDrugModel {
  public constructor() {}

  public id: string | undefined;

  public maxSaleQuantity: string = '5';
  public maxSaleQuantityValidation: string | undefined;

  public minInvoiceAmount: string | undefined = '100000';
  public minInvoiceAmountValidation: string | undefined;

  public percentageSaleAmount: string | undefined = '10';
  public percentageSaleAmountValidation: string | undefined;

  public drugId: string | undefined;

  public brandName: string | undefined;
  public brandNameValidation: string | undefined;
  public genericCode: string | undefined;

  public brandPersianName: string | undefined;
}
